export const cardStyles = {
  width: "100%",
  borderRadius: 3,
  overflow: "hidden",
  textAlign: "left",
  border: "1px solid #EAEAEA",
  display: "flex",
  flexDirection: "column"
};

export const imageStyles = {
  width: "100%",
  height: 160,
  minHeight: 160,
  objectFit: "cover",
};

export const cardContentStyles = {
  flex: 1,
  padding: "32px",
  pt: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};

export const communityNameBoxStyles = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const nameStyles = {
  fontWeight: 500,
  fontSize: 19,
  color: "#2F2B3D",
};

export const managerStyles = {
  fontWeight: 400,
  fontSize: 15,
  color: "#2F2B3D",
  mt: 0.5,
};

export const communityInfoBoxStyles = {
  display: "flex",
  mt: "16px",
  gap: 1,
};

export const communityInfoTextStyles = {
  fontWeight: 400,
  color: "#2F2B3DB2",
  fontSize: 15,
};

export const locationTextStyles = {
  fontWeight: "400",
  color: "#2F2B3D",
  fontSize: 15,
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  cursor: "default",
};

export const tagsTextStyles = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  fontWeight: 400,
  color: "#2F2B3D",
  fontSize: 15,
  cursor: "default",
};

export const joinButtonStyles = {
  mt: "16px",
  backgroundColor: "#257C6D",
  color: "#fff",
  fontSize: 15,
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "6px",
  boxShadow: "none !important",
  "&:hover": { backgroundColor: "#1F6A5A" },
  "&:disabled": { backgroundColor: "#257C6D", color: "#fff", opacity: 0.3 },
};

// Secondary (outlined) button — the grey filled look read as disabled.
export const cancelButtonStyles = {
  mt: "16px",
  backgroundColor: "#fff",
  color: "#257C6D",
  border: "1px solid #257C6D",
  fontSize: 15,
  fontWeight: 500,
  textTransform: "none",
  borderRadius: "6px",
  boxShadow: "none !important",
  "&:hover": {
    backgroundColor: "rgba(37, 124, 109, 0.08)",
    border: "1px solid #1F6A5A",
  },
};
